
{
  "familyId": "STU-WOORDENBOEK",
  "questions": [
    {
      "id": "STU-WOORDENBOEK-001",
      "familyId": "STU-WOORDENBOEK",
      "module": "Studievaardig",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_woordenboek",
      "questionType": "multiple_choice",
      "question": "In een woordenboek staan de woorden op volgorde van het ...",
      "options": ["alfabet", "onderwerp", "aantal letters", "hoe vaak ze gebruikt worden"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Volgorde in een woordenboek",
            "content": "Een woordenboek gebruikt de alfabetische volgorde. Je zoekt een woord op door naar de eerste letter te kijken, dan de tweede, enzovoort.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "woordenboek_volgorde",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "In een woordenboek staan alle woorden op alfabetische volgorde. Je zoekt een woord op door naar de eerste letter te kijken, dan de tweede, enzovoort.",
        "solutionSteps": [
          "Woordenboeken gebruiken alfabetische volgorde",
          "Eerst kijk je naar de eerste letter",
          "Bij dezelfde eerste letter kijk je naar de tweede letter"
        ],
        "distractorExplanations": {
          "0": "Goed! Woordenboeken gebruiken de alfabetische volgorde.",
          "1": "Je dacht waarschijnlijk dat woorden per onderwerp staan. Dat geldt voor een encyclopedie, niet voor een woordenboek. Onthoud: woordenboek = alfabet.",
          "2": "Je dacht waarschijnlijk dat het aantal letters de volgorde bepaalt. Maar 'aap' (3 letters) staat voor 'beer' (4 letters) vanwege de 'a'. Onthoud: de letters bepalen de volgorde, niet het aantal.",
          "3": "Je dacht waarschijnlijk dat veelgebruikte woorden vooraan staan. Maar een woordenboek is altijd alfabetisch geordend. Onthoud: alfabet = vaste volgorde."
        }
      }
    },
    {
      "id": "STU-WOORDENBOEK-002",
      "familyId": "STU-WOORDENBOEK",
      "module": "Studievaardig",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_woordenboek",
      "questionType": "multiple_choice",
      "question": "Je zoekt het woord 'fiets' in het woordenboek. Tussen welke kopwoorden zoek je?",
      "options": ["feest — flat", "draad — egel", "geld — huis", "auto — boot"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kopwoorden gebruiken",
            "content": "Kopwoorden staan bovenaan elke pagina en laten zien welke woorden op die pagina staan. 'Fiets' begint met 'fi-', dat valt tussen 'fe-' (feest) en 'fl-' (flat).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "woordenboek_kopwoorden",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Fiets' begint met 'fi-'. Dat valt tussen 'feest' (fe-) en 'flat' (fl-). Je kijkt naar de eerste twee letters: fe < fi < fl.",
        "solutionSteps": [
          "'Fiets' begint met 'fi'",
          "Vergelijk: fe (feest) < fi (fiets) < fl (flat)",
          "Dus 'fiets' staat tussen 'feest' en 'flat'"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Fiets' (fi-) valt tussen 'feest' (fe-) en 'flat' (fl-).",
          "1": "Je dacht waarschijnlijk dat 'fiets' bij de d of e hoort. Maar 'fiets' begint met 'f', dus het staat na 'egel' (e). Onthoud: kijk naar de eerste letter.",
          "2": "Je dacht waarschijnlijk dat 'fiets' bij de g of h hoort. Maar 'fiets' begint met 'f', dus het staat vóór 'geld' (g). Onthoud: f komt voor g in het alfabet.",
          "3": "Je dacht waarschijnlijk dat 'fiets' bij de a of b hoort. Maar 'fiets' begint met 'f', dus het staat veel verder in het woordenboek. Onthoud: a-b-c-d-e-f."
        }
      }
    },
    {
      "id": "STU-WOORDENBOEK-003",
      "familyId": "STU-WOORDENBOEK",
      "module": "Studievaardig",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_woordenboek",
      "questionType": "multiple_choice",
      "question": "Wat betekent de afkorting 'znw.' in een woordenboek?",
      "options": ["zelfstandig naamwoord", "zinsdeel", "zonder woord", "zeer nuttig woord"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afkortingen in het woordenboek",
            "content": "In een woordenboek staan afkortingen voor woordsoorten: znw. = zelfstandig naamwoord, ww. = werkwoord, bnw. = bijvoeglijk naamwoord, bw. = bijwoord.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "woordenboek_afkortingen",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Znw.' staat voor 'zelfstandig naamwoord'. In een woordenboek zie je vaak afkortingen voor woordsoorten: znw. = zelfstandig naamwoord, ww. = werkwoord, bnw. = bijvoeglijk naamwoord.",
        "solutionSteps": [
          "znw. = zelfstandig naamwoord",
          "ww. = werkwoord",
          "bnw. = bijvoeglijk naamwoord",
          "bw. = bijwoord"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Znw.' is de afkorting voor 'zelfstandig naamwoord'.",
          "1": "Je dacht waarschijnlijk dat 'znw.' voor 'zinsdeel' staat. Maar 'zinsdeel' is een grammaticaal begrip, geen woordsoort. Onthoud: znw. = zelfstandig naamwoord.",
          "2": "Je dacht waarschijnlijk dat 'znw.' voor 'zonder woord' staat. Maar dat is geen woordenboekterm. Onthoud: de afkortingen gaan over woordsoorten.",
          "3": "Je dacht waarschijnlijk dat 'znw.' voor 'zeer nuttig woord' staat. Maar dat is geen echte term. Onthoud: znw. = zelfstandig naamwoord."
        }
      }
    },
    {
      "id": "STU-WOORDENBOEK-004",
      "familyId": "STU-WOORDENBOEK",
      "module": "Studievaardig",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_woordenboek",
      "questionType": "multiple_choice",
      "question": "Je wilt het woord 'fietsen' opzoeken. Onder welk woord zoek je in het woordenboek?",
      "options": ["fietsen (het staat er gewoon in)", "fiets", "fiet", "de letter f"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Woorden opzoeken",
            "content": "In een modern woordenboek staat 'fietsen' als apart trefwoord. Je zoekt het op onder 'fi-'. Werkwoorden en zelfstandige naamwoorden hebben vaak een eigen vermelding.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "woordenboek_opzoeken",
      "variantIndex": 4,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "In een modern woordenboek staat 'fietsen' er gewoon in als apart trefwoord (als werkwoord). Je zoekt het op onder 'fi-'. Sommige woordenboeken verwijzen naar de stam 'fiets'.",
        "solutionSteps": [
          "Zoek op de eerste letters: fi-",
          "Blader naar 'fietsen'",
          "In de meeste woordenboeken staat het als apart trefwoord"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Fietsen' staat in de meeste woordenboeken als apart trefwoord.",
          "1": "Je dacht waarschijnlijk dat je bij 'fiets' moet zoeken. 'Fiets' (het zelfstandig naamwoord) staat er ook in, maar 'fietsen' (werkwoord) heeft een eigen vermelding. Onthoud: werkwoorden staan apart.",
          "2": "Je dacht waarschijnlijk dat je bij 'fiet' moet zoeken. Maar 'fiet' is geen woord en staat niet in het woordenboek. Onthoud: zoek het hele woord op.",
          "3": "Je dacht waarschijnlijk dat je alleen op de letter 'f' zoekt. Maar je moet doorzoeken naar 'fi-' en dan 'fie-'. Onthoud: gebruik de eerste twee of drie letters."
        }
      }
    },
    {
      "id": "STU-WOORDENBOEK-005",
      "familyId": "STU-WOORDENBOEK",
      "module": "Studievaardig",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_woordenboek",
      "questionType": "ordering",
      "question": "Zet deze woorden in de juiste alfabetische volgorde (zoals in een woordenboek).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["appel", "banaan", "ananas", "abrikoos"],
        "correctOrder": [3, 2, 0, 1]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Alfabetische volgorde",
            "content": "Kijk eerst naar de eerste letter. Bij dezelfde eerste letter kijk je naar de tweede letter: ab < an < ap < ba. Dus: abrikoos, ananas, appel, banaan.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "woordenboek_alfabet_ordering",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De juiste volgorde is: abrikoos, ananas, appel, banaan. Alle woorden beginnen met 'a' behalve 'banaan'. Bij dezelfde eerste letter kijk je naar de tweede letter: ab < an < ap < ba.",
        "solutionSteps": [
          "Eerste letter: a, b, a, a → banaan komt als laatste van de a-woorden",
          "Tweede letter van a-woorden: ab, an, ap",
          "b < n < p, dus: abrikoos, ananas, appel",
          "Daarna banaan (begint met b)",
          "Volgorde: abrikoos, ananas, appel, banaan"
        ]
      }
    }
  ]
}
